var styleDataHash = "02fdcf46";
const injectCss = (() => {
  var css = `._8Zp5a{--wds-side-panel-floating-header-padding-left:18px;--wds-side-panel-footer-padding-horizontal:18px}._2t3mv{--wds-color-fill-standard-tertiary-hover:rgba(0,0,0,.1)}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var panel_default = {
  "modal": "_8Zp5a",
  "liveSite": "_2t3mv"
};
export {
  panel_default as default,
  injectCss
};
//# sourceMappingURL=panel-scss.js.map
